var React = require('react');

function ArrowForward (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6.80176 12L5.73976 10.938L9.92676 6.75H0.801758V5.25H9.92676L5.73976 1.062L6.80176 0L12.8018 6L6.80176 12Z","fill":"white"}));
}

ArrowForward.defaultProps = {"width":"13","height":"12","viewBox":"0 0 13 12","fill":"none"};

module.exports = ArrowForward;

ArrowForward.default = ArrowForward;
